var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5713 16.2858C20.5713 17.7429 19.3713 18.8572 17.9999 18.8572H5.9999C4.54275 18.8572 3.42847 17.7429 3.42847 16.2858C3.42847 15.5144 3.77132 14.8286 4.37132 14.3144C5.3999 13.5429 5.9999 12.2572 5.9999 10.9715V9.25721C6.08561 6.25721 8.31418 3.85721 11.1428 3.42864V2.5715C11.1428 2.05721 11.4856 1.71436 11.9999 1.71436C12.5142 1.71436 12.857 2.05721 12.857 2.5715V3.51436C15.7713 3.85721 17.9999 6.34293 17.9999 9.34293V11.0572C17.9999 12.3429 18.5999 13.6286 19.6285 14.4001C20.2285 14.8286 20.5713 15.5144 20.5713 16.2858ZM14.3999 20.5715C14.1428 21.3429 13.5428 21.8572 12.857 22.1144C11.4856 22.5429 10.0285 21.8572 9.5999 20.5715H14.3999Z",
    fill: "url(#paint0_linear_2786_10043)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2786_10043",
    x1: 3.42847,
    y1: 12.0001,
    x2: 20.5713,
    y2: 12.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.ab1de460df69ebd5595ce98932a1abfa.svg";
export { ForwardRef as ReactComponent };